import { createRatesService } from './rate.service';

const ENDPOINT = '/api/intensive_sme_rates';
const IntensiveSMERatesService = createRatesService(ENDPOINT, 'intensive_sme_rate');

export default IntensiveSMERatesService;